/* import __COLOCATED_TEMPLATE__ from './status.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import type SyncSourceWrapper from 'embercom/models/knowledge-hub/sync-source-wrapper';
import { ContentSourceStatusType } from '../content';
import { inject as service } from '@ember/service';

interface Args {
  source: SyncSourceWrapper;
  isEligibleForChatbot: boolean;
  isEligibleForCopilot: boolean;
  usage: {
    agent: number;
    all: number;
    copilot: number;
  };
}

export default class Status extends Component<Args> {
  @service declare appService: AppService;

  contentSourceStatusType = ContentSourceStatusType;

  get contentSourceStatus() {
    let agentEnabledCount = this.args.usage.agent;
    let copilotEnabledCount = this.args.usage.copilot;

    if (this.appService.app.canUseCopilotOnStandalone) {
      if (agentEnabledCount > 0 && copilotEnabledCount > 0) {
        return ContentSourceStatusType.Enabled;
      } else if (agentEnabledCount > 0) {
        return ContentSourceStatusType.EnabledForAgent;
      } else if (copilotEnabledCount > 0) {
        return ContentSourceStatusType.EnabledForCopilot;
      } else {
        return ContentSourceStatusType.NotEnabled;
      }
    } else {
      return agentEnabledCount > 0
        ? ContentSourceStatusType.Enabled
        : ContentSourceStatusType.NotEnabled;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'FinAiAgent::Knowledge::Zendesk::Status': typeof Status;
  }
}
